var React = require('react');

function WaterstreamInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M354 43C309.428 47.2699 216.439 106.931 168.5 183C120.561 259.069 47.6462 554.161 42.5 643.5","stroke":"#C8EDFF","strokeWidth":"85"}));
}

WaterstreamInline.defaultProps = {"width":"304","height":"646","viewBox":"0 0 304 646","fill":"none"};

module.exports = WaterstreamInline;

WaterstreamInline.default = WaterstreamInline;
